import { filesize } from 'filesize'
import { DateTime } from 'luxon'

export default {
  install: (app) => {
    app.config.globalProperties.$filters = {
      date(timestamp, fallback = '##INVALID_TIMESTAMP##', weekday = false, zone = null) {
        return timestamp ? DateTime.fromISO(timestamp, { zone }).toLocaleString(weekday ? DateTime.DATE_HUGE : DateTime.DATE_FULL) : fallback
      },
      time(timestamp, fallback = '##INVALID_TIMESTAMP##', zone = null) {
        if (!timestamp) {
          return fallback
        }

        const time = DateTime.fromISO(timestamp, { zone })
        return time.toLocaleString(DateTime.TIME_SIMPLE) + (zone ? ` ${time.toFormat('ZZZZ')}` : '')
      },
      datetime(timestamp, fallback = '##INVALID_TIMESTAMP##', weekday = false, zone = null) {
        if (!timestamp) {
          return fallback
        }

        const time = DateTime.fromISO(timestamp, { zone })
        return time.toLocaleString(weekday ? DateTime.DATETIME_MED_WITH_WEEKDAY : DateTime.DATETIME_MED) + (zone ? ` ${time.toFormat('ZZZZ')}` : '')
      },
      trans(key, value) {
        // let dictionary = store.enums
        // let pieces = key.split('.')
        // for (let i = 0; i < pieces.length; i++) {
        //   if (!dictionary[pieces[i]]) {
        //     return '###INVALID###'
        //   }

        //   dictionary = dictionary[pieces[i]]
        // }
        // if (typeof value === 'undefined') {
        //   return dictionary || []
        // }

        // const match = dictionary.find((i) => i.id.toString() === value?.toString())
        // if (typeof match !== 'undefined') {
        //   return match.name
        // }

        return '###INVALID###'
      },
      number(number, decimals = false) {
        if (isNaN(number) || number === null) {
          return number
        }

        return number
          .toFixed(decimals ? 2 : 0)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      currency(value, currency = 'GBP', decimals = null) {
        if (decimals === null && !isNaN(value) && value % 1 > 0) {
          decimals = true
        }
        return `${value < 0 ? '-' : ''}${this.trans('property.currencySymbol', currency)}${this.number(Math.abs(value), decimals)}`
      },
      filesize(bytes) {
        return filesize(bytes)
      },
      basename(path) {
        return path.split('/').pop()
      },
    }
  },
}
